// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1RhPn","inner":"Footer_inner__YSz_c","nextIcon":"Footer_nextIcon__CW3xD","innerLeft":"Footer_innerLeft__235ZP"};